import './App.css';
import AppRoutes from './components/routes/routes';
import React from 'react';
import './App.css';


    function App() {


      return(
            <>
               <div>  
                   <main className="globalStyling">
                      <div><AppRoutes /></div> 
                   </main>
               </div>
           </>
         )
      }

export default App;

